import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">RLG & Associates, LLC</h1>
        </header>
        <p className="App-intro">
        RLG & Associates, LLC<br />
        RL Glover, CEO<br />
        461 Riverdale Avenue<br />
        Suite 7G<br />
        Yonkers, NY 10705-2970
        </p>
        <p>
        Home of future corporate software development and consulting
        on a plethora of platforms....
        </p>
        <br />
        <br />
        <h2>Globally Responsive Application Environments</h2>
        <ul  type="square">
          <li>Infrastructure As A Service(iAAS)</li>
          <li>Software As A Service(sAAS)</li>
          <li>Platform As A Service(pAAS)</li>
        </ul>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js